import type { NotificationSchedulerProps } from '@/utils/hooks/context/toast/types';

// Components
import SchedulerNotification from '@/components/composite/Notifications/Scheduler/SchedulerNotification';

const NotificationsScheduler = ({ notification }: NotificationSchedulerProps) => {
    return <SchedulerNotification notification={notification} />;
};

export default NotificationsScheduler;
